import { render, staticRenderFns } from "./OrderResourceAllocation.vue?vue&type=template&id=1abb37cd&scoped=true"
import script from "./OrderResourceAllocation.vue?vue&type=script&lang=js"
export * from "./OrderResourceAllocation.vue?vue&type=script&lang=js"
import style0 from "./OrderResourceAllocation.vue?vue&type=style&index=0&id=1abb37cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abb37cd",
  null
  
)

export default component.exports